<tm-map-spinner [coordinates$]="featureInfoCoordinates$"
                        [loading$]="loadingFeatureInfo$"></tm-map-spinner>
@if ((isMobileLayoutEnabled$ | async) === false) {
  <tm-feature-info-dialog></tm-feature-info-dialog>
}
